<template>
  <div class="main-content">
    <div class="reg">
      <h3>用户注册</h3>
      <UserRegisterForm :inviteKey="inviteKey"></UserRegisterForm>
    </div>
  </div>
</template>

<script>
import UserRegisterForm from "@/components/UserRegisterForm";
export default {
  name: "Register",
  components: { UserRegisterForm },
  computed: {
    inviteKey() {
      return this.$route.query["invite_key"];
    }
  }
};
</script>

<style scoped lang="scss">
.reg {
  width: 400px;
  margin-top: 30%;
  margin-left: 50%;
  transform: translate(-50%, -50%);
}
</style>
